import deviceImg from '../product-starter-set.png';
import extensionImg from '../product-extension-pack.png';
import hygieneImg from '../product-hygiene-pack.png';

const TEAL = '#14b8a6';

const PRODUCT_META = {
  starter: { id: 'starter', img: deviceImg, imgBg: '#111827', ctaStyle: 'primary', badgeColor: TEAL },
  extension: { id: 'extension', img: extensionImg, imgBg: '#f8fafc', ctaStyle: 'secondary', badgeColor: '#6366f1' },
  hygiene: { id: 'hygiene', img: hygieneImg, imgBg: '#f8fafc', ctaStyle: 'secondary', badgeColor: '#0ea5e9' },
};

export function getShopProducts(t) {
  return ['starter', 'extension', 'hygiene'].map((key) => {
    const p = t(`shop.products.${key}`, { returnObjects: true });
    return { ...PRODUCT_META[key], ...p };
  });
}
